module.exports = __webpack_public_path__ + "b5a20b5dc33f025dd38b4fc15d6ede78.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/header_logo.png
// module id = 160
// module chunks = 0 1